import moment from 'moment-timezone';
import qs from 'qs';
import {
  TEMPLATES_REQUEST,
  TEMPLATES_FAILURE,
  TEMPLATES_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function templatesRequest() {
  return {
    type: TEMPLATES_REQUEST,
  };
}

function templatesSuccess(type, data, token = null) {
  return {
    type: TEMPLATES_SUCCESS,
    payload: {
      type,
      data,
      token,
    },
  };
}

function templatesError(message) {
  return {
    type: TEMPLATES_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchTemplates(templateType, fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(templatesRequest());
    if (!fresh) {
      let templatesData = {};
      try {
        templatesData = JSON.parse(getItem(`${config.get('appName')}.templates.${templateType}`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !templatesData.data ||
        config.get('version') !== templatesData.version ||
        moment().isAfter(moment(templatesData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(templatesSuccess(templateType, templatesData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
      templateType,
    });
    return dispatch(fetchM(`/templates/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.templates.${templateType}`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(templatesSuccess(templateType, data, token));
      })
      .catch(err => dispatch(handleError(err, templatesError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/templates.js